import workEmployment from './work-employment.json';
import education from './education.json';
import travelBasics from './travel-basics.json';
import foodRestaurant from './food-restaurant.json';
import cashlessSociety from './cashless-society.json';
import idiomsResolution from './idioms-resolution.json';

export const setsMeta = [
  { id: 'work-employment', title: 'Work & Employment Vocabulary', topic: 'Work' },
  { id: 'education', title: 'Education Vocabulary', topic: 'Education' },
  { id: 'travel-basics', title: 'Travel Essentials', topic: 'Travel' },
  { id: 'food-restaurant', title: 'Food & Restaurant', topic: 'Food' },
  { id: 'cashless-society', title: 'Cashless Society', topic: 'Cashless Society' },
  { id: 'idioms-resolution', title: 'Idioms about making a new start', topic: 'Resolution Idioms' },
];

const setData = {
  'work-employment': workEmployment,
  'education': education,
  'travel-basics': travelBasics,
  'food-restaurant': foodRestaurant,
  'cashless-society': cashlessSociety,
  'idioms-resolution': idiomsResolution,
};

export function loadSet(id) {
  return Promise.resolve(setData[id]);
}